<template>
  <div class="doctor-box">
    <div class="doctor-tab-list">
      <div class="doctor-tab" v-for="item in tab_list" @click="handleChangeTab(item.key)" :key="item.key" :class="{'tab-active':active_type == item.key}">{{item.value}}</div>
    </div>
    <loadMore
      class="shop-load-more"
      v-if="shop_list.length>0"
      :onLoadMore="onLoadMore"
      :enableLoadMore="enableLoadMore"
    >
      <div class="doctor-list" v-for="(item,index) in shop_list" :key="index" @click="handleToOrderDetail(item.id,item.status)">
        <div class="doctor-list-top flex_s_c">
          <img :src="item.avatar" alt />
          <div class="doctor-detail font-85">{{item.docname?item.docname+'医生的治疗方案':''}}</div>
          <div
            class="doctor-num"
            :class="{'is_one':item.status == 6||item.status == 5,'is_two':item.status >= 1 && item.status <= 3,'is_three':item.status == 4 }"
          >{{item.status | charge_status}}</div>
        </div>
        <div class="shop-box"></div>
        <div class="shop-list">
          <div class="shop-list-detail flex_s_c">
            <div class="s-l-d-left font-65">支付费用：</div>
            <div class="s-l-d-right font-85">{{(item.charge_amount).toFixed(2)}}元</div>
          </div>
          <div class="shop-list-detail flex_s_c">
            <div class="s-l-d-left font-65">开方时间：</div>
            <div class="s-l-d-right font-85">{{item.time}}</div>
          </div>
        </div>
      </div>
    </loadMore>
    <div class="doctor-null flex_s_c_w" v-if="shop_list.length == 0">
      <img src="../../../static/icons/gouyao@3x.jpg" alt />
      <div class="doctor-null-txt font-85">暂无购药记录</div>
    </div>
  </div>
</template>
<script>
import http from "../../request/http";
import { formatDate } from "../../utils/index";
import loadMore from "../loadMore";
export default {
  data() {
    return {
      shop_list: [],
      enableLoadMore: true,
      page: 1,
      tab_list:[{key:0,value:'全部'},{key:1,value:'待支付'},{key:2,value:'待发药'},{key:4,value:'已超时'}],
      active_type:0
    };
  },
  components: {
    loadMore,
  },
  filters: {
    charge_status(val) {
      let txt = "";
      switch (val) {
        case "1":
          txt = "待支付";
          break;
        case "2":
          txt = "待审方";
          break;
        case "3":
          txt = "待发药";
          break;
        case "4":
          txt = "已发药";
          break;
        case "5":
          txt = "已作废";
          break;
        case "6":
          txt = "已超时";
          break;
        default:
          txt = "";
      }
      return txt;
    },
  },
  created() {
    if(this.$route.query.active_type){
      this.active_type = this.$route.query.active_type;
    }
    this.getShopList();
  },
  methods: {
    handleChangeTab(tab){
      this.active_type = tab;
      this.page = 1;
      this.enableLoadMore = true;
      this.getShopList()
    },
    handleToOrderDetail(id,status){
      // if(status == 1){
      //   this.$router.push('/order_pay?orderid='+id)
      // }else{
        this.$router.push('/order_pay_detail?orderid='+id)
      // }
    },
    onLoadMore(done) {
      setTimeout(() => {  
        if (!this.enableLoadMore) {
          return;
        }
        this.page = this.page + 1;
        this.getShopList(() => {
          done();
        });
      }, 200);
    },
    getShopList(done = function () {}) {
      let data = {
        pageIndex: this.page,
        status:this.active_type == 0?'':this.active_type
      };
      http
        .post("/api/wap/user/yaolist",data)
        .then((res) => {
          done();
          if (res.data) {
            res.data.forEach((v) => {
              v.time = formatDate(v.ctime * 1000);
            });
            if (res.data.length < 10) {
              this.enableLoadMore = false;
            }
            if (this.page == 1) {
              this.shop_list = res.data;
            } else {
              this.shop_list = this.shop_list.concat(res.data);
            }
          } else {
            this.shop_list = [];
          }
        })
        .catch((err) => {
          done();
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
@import "./doctor.css";
@import "./issue.css";
.doctor-box{
  height: 100vh;
  padding:0;
}
.shop-load-more {
  height:calc(100vh - 2.4rem);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  transition-duration: 300ms;
}
.is_one {
  color: rgba(0, 0, 0, 0.65);
}
.is_two {
  color: rgba(250, 84, 28, 1);
}
.is_three {
  color: rgba(24, 144, 255, 1);
}
.doctor-list{
  width:100vw;
  border-radius: 0;
}
.doctor-tab{
  width: 25%;
}
.doctor-null{
  height: calc(100vh - 2.9rem);
  margin-top: 0.5rem;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/pages/user/my_shop_car.vue